import { Base } from "./collections.base";
import { Collection } from "./components/collection";

export const Collections = Object.assign(Base, {
    Collection: Collection
});
